import { DateFormatters } from 'app/infrastructure/data/types';
import { FilterCommonTypes } from '../types-store';
import { FilterCommonValues, SubOptionType } from './types';

export const createDate = (
  formatters: DateFormatters,
  value: FilterCommonTypes
): string => {
  return value instanceof Date && formatters.formatDate(value, { day: 'numeric', month: 'short', year: 'numeric' });
};

export const createDateValue = (
  value: FilterCommonValues<FilterCommonTypes>[],
  subOptionType: SubOptionType,
  formatters: DateFormatters
): string => {
  const date = value && value.find(f => f.subOptionType === subOptionType);
  return date && createDate(formatters, date.value);
};
